import styled from "styled-components";

import { Fonts } from "assets/fonts";

/** From boost-react-weabapp, updated on 08.03.2023 */

const NoResultsMessage = styled.p`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 32px auto;
  text-align: center;
  ${Fonts.regular_14}
  line-height: 2em;
  color: ${(p) => p.theme.textMediumContrast};

  strong {
    font-size: 16px;
  }
`;

export const NoResult = () => {
  return (
    <NoResultsMessage>
      <strong>No results</strong>
    </NoResultsMessage>
  );
};
